import { render, staticRenderFns } from "./TenantUserCreate.vue?vue&type=template&id=1ff22b89"
import script from "./TenantUserCreate.vue?vue&type=script&lang=ts"
export * from "./TenantUserCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports